<template>
  <f-form
      store="@admin/users"
      :id="adminId"
    >
      <template #default="{ item }">
        <div class="is-grid">

          {{ item.email }}
          
          <f-field 
            class="is-col-6"
            label="Mot de passe"
          >
            <f-input 
              type="password"
              v-model="item.password"
              suffix-icon="shield"
            ></f-input>
          </f-field>
        </div>
      </template>
    </f-form>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'

  export default {
    setup () {
      const adminId = computed(() => router.currentRoute.value.params.id)
      
      return {
        adminId,
      }
    } 
  }
</script>